module.exports = __webpack_public_path__ + "img/企修通工程师端软著登记证书.44a9c65d.png";